import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';

import scss from './HeadToHeadDisclaimer.module.scss';

function HeadToHeadDisclaimer({ topMessage, selectedMessages }) {
  const { t } = useTranslation('resonance');

  return (
    <div className={scss.wrapper}>
      <div className={scss.titleWrapper}>
        <Icon icon={ICONS.Unclust} className={scss.icon} disableCommonStyles currentColor />
        <h3>{t('noData')}</h3>
      </div>
      <span className={scss.subtitle}>
        {t('pleaseSelect')}
        {': '}
        <span className={clsx(scss.subtitleItem, topMessage && scss.subtitleItemSelected)}>{t('topMessage')}</span>
        <span> {t('and')} </span>
        <span className={clsx(scss.subtitleItem, selectedMessages.length && scss.subtitleItemSelected)}>
          {t('message')}
        </span>
      </span>
    </div>
  );
}

export default HeadToHeadDisclaimer;
